import { useState } from 'react';
import axios from 'axios';

const useApiPost = (accessKey) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const postRequest = async (url, formData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(url, formData, {
        headers: {
          'access-key': `${accessKey}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setData(response.data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return { data, error, loading, postRequest, setData };
};

export default useApiPost;
